import {computed} from "vue";
import {filterEmptyKeys} from "@/lib/utils";
import useSwr from "@/core/composables/swr/useSwr";
import {laboratoryApi} from "@/container";

export interface LaboratoryOfferProductsAnalysisSearchParams {
    size?: number;
    page?: number;
}

/**
 * Composable to get the analysis of products for a laboratory.
 *
 * @param laboratoryId
 * @param offerId
 * @param searchParams
 */
const useLaboratoryOfferProductsAnalysis = (
    laboratoryId: string,
    offerId: string,
    searchParams: LaboratoryOfferProductsAnalysisSearchParams
) => {
    const swrKey = computed(() => {
        const query = new URLSearchParams(filterEmptyKeys(searchParams));

        return `/laboratories/${laboratoryId}/offers/${offerId}/products?${query.toString()}`;
    });

    const {data, error, isLoading, isValidating, mutate} = useSwr(
        swrKey,
        () => laboratoryApi().offerProducts(
            laboratoryId,
            offerId,
            searchParams
        ),
        {
            revalidateOnFocus: false,
            ttl: 1000 * 60 * 5,
            errorRetryCount: 0
        }
    );

    return {
        data,
        error,
        isLoading,
        isValidating,
        mutate
    };
};

export default useLaboratoryOfferProductsAnalysis;
